export default __webpack_public_path__ + "c00e7e058a162db561741f7eeec360fc.webp";